export default "__VITE_ASSET__0bbe8b3c__"